
import { ColumnDef } from '@/pages/search/results/table/table-layout';
import Vue from 'vue';
export default Vue.component('TableHeader', {
	props: {
		disabled: Boolean,
		col: Object as () => ColumnDef
	},
	methods: {
		changeSort(sort: string) { this.$emit('changeSort', sort); }
	}
})
